enum ArrowType {
  CONVOY,
  MOVE,
  SUPPORT,
  HOLD,
}

export default ArrowType;
